import { render, staticRenderFns } from "./Editmodal.vue?vue&type=template&id=164ceaef"
import script from "./Editmodal.vue?vue&type=script&lang=ts"
export * from "./Editmodal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports